module.exports = __webpack_public_path__ + "img/NOT_ALLOWED.2a49ead0.svg";